import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { confirmDialogSignal } from './confirm.signals';

@Component({
  selector: 'kon-confirm-dialog',
  standalone: true,
  imports: [CommonModule, RouterModule, ConfirmDialogModule],
  providers: [ConfirmationService],
  template: `<p-confirmDialog
    [autoZIndex]="true"
    [baseZIndex]="10000"
    (onHide)="clearConfirmation()"
    [style]="{ maxWidth: 'min(95vw, 40rem)', minWidth: '30vw' }"
  ></p-confirmDialog>`,
  styles: `
        :host ::ng-deep .p-dialog.p-confirm-dialog {
          .p-confirm-dialog-message {
            margin-left: unset;
          }
          .p-confirm-dialog-icon {
            margin-right: 1rem;
          }
        }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  private confirmationService = inject(ConfirmationService);

  constructor() {
    effect(() => {
      const confirmation = confirmDialogSignal();
      if (confirmation) {
        this.confirmationService.confirm(confirmation);
      }
    });
  }

  clearConfirmation() {
    confirmDialogSignal.set(undefined);
  }
}
